import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tooltipDefaultVariants = {
  "position": "bottom"
}
const tooltipCompoundVariants = [
  {
    "position": [
      "top",
      "top-start",
      "top-end"
    ],
    "caret": true,
    "css": {
      "tooltipContent": {
        "mb": "12"
      }
    }
  },
  {
    "position": [
      "top",
      "top-start",
      "top-end"
    ],
    "caret": false,
    "css": {
      "tooltipContent": {
        "mb": "8"
      }
    }
  },
  {
    "position": [
      "bottom",
      "bottom-start",
      "bottom-end"
    ],
    "caret": true,
    "css": {
      "tooltipContent": {
        "mt": "12"
      }
    }
  },
  {
    "position": [
      "bottom",
      "bottom-start",
      "bottom-end"
    ],
    "caret": false,
    "css": {
      "tooltipContent": {
        "mt": "8"
      }
    }
  },
  {
    "position": [
      "left",
      "left-start",
      "left-end"
    ],
    "caret": true,
    "css": {
      "tooltipContent": {
        "mr": "12"
      }
    }
  },
  {
    "position": [
      "left",
      "left-start",
      "left-end"
    ],
    "caret": false,
    "css": {
      "tooltipContent": {
        "mr": "8"
      }
    }
  },
  {
    "position": [
      "right",
      "right-start",
      "right-end"
    ],
    "caret": true,
    "css": {
      "tooltipContent": {
        "ml": "12"
      }
    }
  },
  {
    "position": [
      "right",
      "right-start",
      "right-end"
    ],
    "caret": false,
    "css": {
      "tooltipContent": {
        "ml": "8"
      }
    }
  }
]

const tooltipSlotNames = [
  [
    "wrapper",
    "tooltip__wrapper"
  ],
  [
    "tooltipContent",
    "tooltip__tooltipContent"
  ]
]
const tooltipSlotFns = /* @__PURE__ */ tooltipSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tooltipDefaultVariants, getSlotCompoundVariant(tooltipCompoundVariants, slotName))])

const tooltipFn = memo((props = {}) => {
  return Object.fromEntries(tooltipSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tooltipVariantKeys = [
  "position",
  "caret"
]
const getVariantProps = (variants) => ({ ...tooltipDefaultVariants, ...compact(variants) })

export const tooltip = /* @__PURE__ */ Object.assign(tooltipFn, {
  __recipe__: false,
  __name__: 'tooltip',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tooltipVariantKeys,
  variantMap: {
  "position": [
    "top",
    "bottom",
    "left",
    "right",
    "top-start",
    "bottom-start",
    "left-start",
    "right-start",
    "top-end",
    "bottom-end",
    "left-end",
    "right-end"
  ],
  "caret": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tooltipVariantKeys)
  },
  getVariantProps
})